module.exports = __webpack_public_path__ + "static/media/go_back.d5539e3b.svg";